import { render, staticRenderFns } from "./AxBatchUpdateDialog.vue?vue&type=template&id=a4204690&scoped=true"
import script from "./AxBatchUpdateDialog.vue?vue&type=script&lang=ts"
export * from "./AxBatchUpdateDialog.vue?vue&type=script&lang=ts"
import style0 from "./AxBatchUpdateDialog.vue?vue&type=style&index=0&id=a4204690&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4204690",
  null
  
)

export default component.exports